export default __webpack_public_path__ + "static/media/EE.b4b2b4d9.svg";